import { atom } from 'jotai';

export const ROUTINES_SPOTLIGHT_TOTAL_STEPS = 4;

export type RoutinesSpotlightStep = 1 | 2 | 3 | 4;

/**
 * Current step of the Routines onboarding spotlight tour, or null when not
 * running. The whole tour shares one modal-queue slot
 * (`ModalId.T4_CUSTOM_AUDIENCE_ROUTINES_ONBOARDING_SPOTLIGHT`); stepping is
 * internal and never re-enters the queue.
 */
export const routinesSpotlightStepAtom = atom<RoutinesSpotlightStep | null>(null);

/**
 * Whether the chat-sidebar Routines entry (step 1) is mounted. Set by
 * RoutinesSidebarNavEntry. The tour only enqueues while this is true so it
 * never grabs a queue slot on a surface where the first anchor does not exist.
 */
export const routinesSpotlightSidebarAnchorsMountedAtom = atom(false);

/**
 * Tour asks the already-open ChatSidebar to expand. Written by the tour hook;
 * read by RoutinesSidebarNavEntry so workflows/spotlight never imports chatAtoms.
 */
export const routinesSpotlightNeedsSidebarOpenAtom = atom(false);

/**
 * Chat sidebar reports it is open (and the Routines row is visible). Written by
 * RoutinesSidebarNavEntry; the tour waits on this before setStep(1).
 */
export const routinesSpotlightSidebarReadyAtom = atom(false);

/**
 * Whether the Routines browse list (steps 2–4: Discover, Create, All) is
 * mounted. Set by WorkflowsListPanel. Missing mid-tour on those steps closes
 * the tour so it cannot sit invisible while holding the queue slot.
 */
export const routinesSpotlightListAnchorsMountedAtom = atom(false);
